"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandsImpl = void 0;
class CommandsImpl {
    constructor(txt, et) {
        this.txt = txt;
        this.et = et;
    }
    FormatToggle(tag) {
        this.et.format('tog', typeof tag === 'number' ? tag : tag + '');
    }
    Caret(gap) {
        this.et.cursor({ at: [Number(gap)] });
    }
    Delete() {
        this.et.delete({});
    }
    Insert(text) {
        this.et.insert(text + '');
    }
    MoveLeft(steps = 1) {
        this.et.cursor({ move: [['focus', 'vchar', -steps, true]] });
    }
    MoveRight(steps = 1) {
        this.et.cursor({ move: [['focus', 'vchar', steps, true]] });
    }
    CharLeft() {
        return this.txt.editor.mainCursor()?.focus().leftChar()?.view() || '';
    }
    CharRight() {
        return this.txt.editor.mainCursor()?.focus().rightChar()?.view() || '';
    }
}
exports.CommandsImpl = CommandsImpl;
